import { connect } from 'react-redux';

import { IState } from '../../store';
import { ISimilarNewObjectsProps, SimilarNewObjects } from './index';
import { getUserEBC } from '../../utils/tracking/get_user_ebc';
import { getPageEBC } from '../../utils/tracking/get_page_ebc';

function mapStateToProps(state: IState): ISimilarNewObjectsProps {
  return {
    similarNewObjects: state.offerData.similarNewObjects,
    agent: state.offerData.agent,
    offer: state.offerData.offer,
    user: getUserEBC(state.offerData.user, state.abGroup),
    page: getPageEBC(state.offerData.offer.id, state.offerData.breadcrumbs),
  };
}

export const SimilarNewObjectsContainer = connect<ISimilarNewObjectsProps, {}, {}>(mapStateToProps)(SimilarNewObjects);
